import React from 'react';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-slate-800 to-gray-900 overflow-hidden">
      {/* Animated background particles */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-1 h-1 bg-red-400 rounded-full animate-bounce" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute top-60 left-1/3 w-1.5 h-1.5 bg-blue-300 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-80 right-1/3 w-1 h-1 bg-yellow-300 rounded-full animate-bounce" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-96 left-1/2 w-2 h-2 bg-red-500 rounded-full animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      {/* Navigation */}
      <nav className="bg-black/80 backdrop-blur-md border-b-2 border-gradient-to-r from-yellow-400 via-red-500 to-blue-500">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3 ml-0">
              <div className="bg-black/20 backdrop-blur-sm rounded-xl p-1 border border-yellow-400/30">
                <img 
                  src="https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/4a7f8b54088d811b1f1eaf12115718e6.jpeg" 
                  alt="ESPECTÁCULOS BRONCHÚ Logo" 
                  className="h-14 w-14 rounded-lg shadow-lg object-cover"
                />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white tracking-widest drop-shadow-2xl" style={{fontFamily: 'Playfair Display, serif', textShadow: '2px 2px 4px rgba(0,0,0,0.8)'}}>
                  ESPECTÁCULOS BRONCHÚ
                </h1>
                <p className="text-xs text-yellow-400 font-light tracking-widest" style={{letterSpacing: '0.25em', fontFamily: 'Playfair Display, serif'}}>
                  L'ART DEL FOC I EL SO
                </p>
              </div>
            </div>

            {/* Navigation Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-yellow-400 border-b-2 border-yellow-400 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                INICIO
              </a>
              <a href="/pirotecnia" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                PIROTECNIA
              </a>
              <a href="/eventos" className="text-white hover:text-red-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                EVENTOS
              </a>
              <a href="/videos" className="text-white hover:text-blue-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                VIDEOS
              </a>
              <a href="/calendario" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CALENDARIO
              </a>
              <a href="/merchandising" className="text-white hover:text-yellow-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                MERCHANDISING
              </a>
              <a href="/nosotros" className="text-white hover:text-red-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                NOSOTROS
              </a>
              <a href="/contacto" className="text-white hover:text-blue-400 transition-colors duration-300 font-semibold tracking-wider text-sm cursor-pointer whitespace-nowrap">
                CONTACTO
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/f83f5cd629da4d80734129e80e4e4145/4ed5aea880f5ef0f536102062680fdb7.png')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <div className="mb-6 sm:mb-8">
            <span className="inline-block bg-gradient-to-r from-yellow-400/20 to-red-500/20 backdrop-blur-sm border border-yellow-400/50 text-yellow-400 px-4 sm:px-6 py-2 sm:py-3 rounded-full text-xs sm:text-sm font-bold tracking-widest mb-4 sm:mb-6">
              <i className="ri-star-fill mr-2"></i>
              17 AÑOS DE EXPERIENCIA
            </span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black text-white mb-4 sm:mb-6 tracking-wider leading-tight px-2" style={{fontFamily: 'Playfair Display, serif', textShadow: '0 0 40px rgba(0,0,0,0.8), 0 0 80px rgba(251,191,36,0.3)'}}>
            PIROTECNIA
            <span className="block bg-gradient-to-r from-yellow-300 via-orange-400 to-red-500 bg-clip-text text-transparent" style={{textShadow: '0 0 60px rgba(251,191,36,0.6)'}}>
              &amp; SONIDO
            </span>
          </h1>
          
          <p className="text-base sm:text-xl md:text-2xl lg:text-3xl text-gray-200 mb-8 sm:mb-12 font-light tracking-wide max-w-4xl mx-auto leading-relaxed px-4" style={{textShadow: '2px 2px 8px rgba(0,0,0,0.8)'}}>
            Fuegos artificiales • Discomóviles • DJ Projecte
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-4">
            <a href="/contacto" className="w-full sm:w-auto bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-black px-6 sm:px-10 py-4 sm:py-5 rounded-full font-bold text-base sm:text-lg tracking-wider hover:scale-105 transition-transform duration-300 shadow-2xl cursor-pointer whitespace-nowrap text-center">
              <i className="ri-fire-line mr-2"></i>
              PRESUPUESTO
            </a>
            <a href="/videos" className="w-full sm:w-auto bg-white/10 backdrop-blur-md border-2 border-white/50 text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full font-bold text-base sm:text-lg tracking-wider hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap text-center">
              <i className="ri-play-circle-line mr-2"></i>
              VER VIDEOS
            </a>
          </div>
        </div>
      </section>

      {/* Servicios Principales */}
      <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-slate-800 to-slate-700 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-3 sm:mb-4 md:mb-6 tracking-wider drop-shadow-lg leading-tight px-2" style={{fontFamily: 'Playfair Display, serif'}}>
              NUESTROS SERVICIOS
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed font-light px-4">
              MÁS DE 17 AÑOS CREANDO ESPECTÁCULOS ÚNICOS
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            {/* Pirotécnica */}
            <a href="/pirotecnia" className="group cursor-pointer">
              <div 
                className="h-80 md:h-96 bg-cover bg-center rounded-2xl overflow-hidden relative border-4 border-red-400/30 group-hover:border-red-500 transition-all duration-300 group-hover:scale-105"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=spectacular%20mascleta%20fireworks%20display%20with%20intense%20bright%20explosions%2C%20brilliant%20red%20yellow%20blue%20orange%20sparks%2C%20vibrant%20colors%2C%20dramatic%20smoke%20clouds%2C%20Valencia%20Spain%2C%20traditional%20Spanish%20celebration%20with%20dazzling%20vivid%20pyrotechnics&width=600&height=384&seq=mascleta-vivid&orientation=landscape')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent group-hover:from-black/60 transition-all duration-300"></div>
                <div className="absolute top-4 md:top-6 left-4 md:left-6">
                  <span className="bg-red-500 text-white px-3 md:px-4 py-1 md:py-2 rounded-full text-xs md:text-sm font-bold flex items-center space-x-2">
                    <i className="ri-fire-line"></i>
                    <span className="hidden sm:inline">FUEGOS ARTIFICIALES</span>
                    <span className="sm:hidden">FUEGOS</span>
                  </span>
                </div>
                <div className="absolute bottom-6 md:bottom-8 left-6 md:left-8 right-6 md:right-8">
                  <h3 className="text-white text-xl sm:text-2xl md:text-3xl font-bold tracking-wider mb-3 md:mb-4 leading-tight">
                    FUEGOS ARTIFICIALES<span className="block sm:inline"> PROFESIONALES</span>
                  </h3>
                  <p className="text-gray-200 text-base md:text-lg mb-4 md:mb-6">
                    Mascletas en miniatura, castillos, bodas y eventos corporativos
                  </p>
                  <div className="flex items-center text-yellow-400 font-semibold text-sm md:text-base">
                    <span>DESCUBRIR MÁS</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </div>
            </a>

            {/* Eventos */}
            <a href="/eventos" className="group cursor-pointer">
              <div 
                className="h-80 md:h-96 bg-cover bg-center rounded-2xl overflow-hidden relative border-4 border-blue-400/30 group-hover:border-blue-500 transition-all duration-300 group-hover:scale-105"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20DJ%20and%20sound%20system%20setup%20with%20brilliant%20colorful%20party%20lights%2C%20vibrant%20neon%20colors%2C%20people%20dancing%20energetically%2C%20dazzling%20bright%20dance%20floor%2C%20mobile%20disco%20with%20saturated%20lighting%2C%20concert%20atmosphere%20with%20vivid%20colors&width=600&height=384&seq=dj-vivid&orientation=landscape')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent group-hover:from-black/60 transition-all duration-300"></div>
                <div className="absolute top-4 md:top-6 left-4 md:left-6">
                  <span className="bg-blue-500 text-white px-3 md:px-4 py-1 md:py-2 rounded-full text-xs md:text-sm font-bold flex items-center space-x-2">
                    <i className="ri-music-line"></i>
                    <span>EVENTOS</span>
                  </span>
                </div>
                <div className="absolute bottom-6 md:bottom-8 left-6 md:left-8 right-6 md:right-8">
                  <h3 className="text-white text-xl sm:text-2xl md:text-3xl font-bold tracking-wider mb-3 md:mb-4 leading-tight">
                    SONIDO Y<span className="block sm:inline"> ENTRETENIMIENTO</span>
                  </h3>
                  <p className="text-gray-200 text-base md:text-lg mb-4 md:mb-6">
                    Sonorización profesional, discomóviles y DJ Projecte
                  </p>
                  <div className="flex items-center text-blue-400 font-semibold text-sm md:text-base">
                    <span>DESCUBRIR MÁS</span>
                    <i className="ri-arrow-right-line ml-2"></i>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-24 md:py-32">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=panoramic%20night%20mascleta%20fireworks%20display%20over%20Valencia%20city%2C%20spectacular%20bright%20colorful%20explosions%2C%20brilliant%20golden%20orange%20red%20sparks%2C%20dramatic%20vivid%20evening%20sky%2C%20urban%20landscape%20with%20intense%20vibrant%20pyrotechnics%2C%20saturated%20colors%2C%20dazzling%20wide%20angle%20view&width=1920&height=800&seq=valencia-night-vivid&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/60 to-gray-800/50"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center">
            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 md:mb-8 tracking-wider drop-shadow-2xl leading-tight" style={{fontFamily: 'Playfair Display, serif'}}>
              ¿LISTO PARA<br />TU EVENTO?
            </h2>
            <p className="text-lg md:text-xl text-gray-300 mb-8 md:mb-12 max-w-2xl mx-auto px-4">
              Contacta con nosotros y crearemos un espectáculo único e inolvidable para tu evento especial
            </p>
            <div className="flex flex-col lg:flex-row items-center justify-center space-y-4 lg:space-y-0 lg:space-x-8">
              <a href="/contacto" className="bg-gradient-to-r from-red-500 via-yellow-400 to-blue-500 text-white px-8 md:px-12 py-4 md:py-6 rounded-full font-bold text-lg md:text-xl tracking-wider hover:scale-105 transition-transform duration-300 flex items-center space-x-4 cursor-pointer whitespace-nowrap">
                <span className="hidden sm:inline">SOLICITAR PRESUPUESTO</span>
                <span className="sm:hidden">PRESUPUESTO</span>
                <div className="bg-white text-black w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center">
                  <i className="ri-rocket-line text-lg md:text-xl"></i>
                </div>
              </a>
              <div className="text-white text-center lg:text-right">
                <div className="text-base md:text-lg font-light tracking-wider leading-relaxed">
                  PRESUPUESTO SIN<span className="block sm:inline"> COMPROMISO</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-t from-slate-800 to-gray-700 py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
            {/* Logo y Descripción */}
            <div className="lg:col-span-2">
              <h3 className="text-white text-2xl font-bold mb-4" style={{fontFamily: 'Playfair Display, serif'}}>
                ESPECTÁCULOS BRONCHÚ
                <span className="text-yellow-400 text-lg">.</span>
              </h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Especialistas en pirotécnica profesional y entretenimiento con más de 17 años de experiencia creando momentos únicos e inolvidables.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="border-2 border-yellow-400 text-yellow-400 w-10 h-10 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="border-2 border-yellow-400 text-yellow-400 w-10 h-10 rounded-lg flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all duration-300 cursor-pointer">
                  <i className="ri-youtube-line"></i>
                </a>
              </div>
            </div>

            {/* Enlaces Rápidos */}
            <div>
              <h4 className="text-white font-bold text-lg mb-6 tracking-wider">SERVICIOS</h4>
              <ul className="space-y-3">
                <li><a href="/pirotecnia" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">FUEGOS ARTIFICIALES</a></li>
                <li><a href="/eventos" className="text-gray-300 hover:text-red-400 transition-colors duration-300 cursor-pointer">EVENTOS</a></li>
                <li><a href="/videos" className="text-gray-300 hover:text-blue-400 transition-colors duration-300 cursor-pointer">GALERÍA</a></li>
                <li><a href="/calendario" className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">CALENDARIO</a></li>
              </ul>
            </div>

            {/* Contacto */}
            <div>
              <h4 className="text-white font-bold text-lg mb-6 tracking-wider">CONTACTO</h4>
              <ul className="space-y-3">
                <li className="text-gray-300">693 812 675</li>
                <li className="text-gray-300">info@espectaculosbronchu.es</li>
                <li className="text-gray-300">VALENCIA, ESPAÑA</li>
                <li><a href="/contacto" className="text-yellow-400 hover:underline cursor-pointer">SOLICITAR PRESUPUESTO</a></li>
              </ul>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col lg:flex-row items-center justify-between">
            <p className="text-gray-400 text-sm mb-4 lg:mb-0">
              © 2025 ESPECTÁCULOS BRONCHÚ. TODOS LOS DERECHOS RESERVADOS
            </p>
            
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-yellow-400 transition-colors duration-300 cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
